import { Component, Input, OnInit } from "@angular/core";
import { DataService_MultiStationViewVisitors } from "../shared/data.service";
import { VisitorOffenderUpdateRequest } from "../shared/VisitorOffenderUpdateRequest";
import { ConfirmationService } from "primeng/api";
import { MsPrintPassInstructionsComponent } from "./ms-print-pass-instructions/ms-print-pass-instructions.component";
import { DialogService } from "primeng/dynamicdialog";

@Component({
	selector: "caass-ms-visitor-offender-lookup",
	templateUrl: "./ms-visitor-offender-lookup.component.html",
	styleUrls: ["./ms-visitor-offender-lookup.component.css"],
})
export class MsVisitorOffenderLookupComponent implements OnInit {
	constructor(
		private visitorService: DataService_MultiStationViewVisitors,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		this.loadOffenders();
	}

	ngOnChanges() {
		this.loadOffenders();
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////

	@Input() SelectedVisitor: any;

	Processing: boolean = false;
	loading: boolean = false;

	lstNotVerified: any = [];
	lstVerified: any = [];
	sortField: string;
	sortOrder: number;
	sortOptions: any = [
		{ label: "Confirmed? Yes to No", value: "IsFalseHit" },
		{ label: "Confirmed? No to Yes", value: "!IsFalseHit" },
		{ label: "Last Modified Date Newest to Oldest", value: "!c_date" },
		{ label: "Last Modified Date Oldest to Newest", value: "c_date" },
		{ label: "Date of Birth Newest to Oldest", value: "!DOB" },
		{ label: "Date of Birth Oldest to Newest", value: "DOB" },
		{ label: "Offender Status A to Z", value: "OffenderStatus" },
		{ label: "Offender Status Z to A", value: "!OffenderStatus" },
		{ label: "State A to Z", value: "State" },
		{ label: "State Z to A", value: "!State" },
		{ label: "Conviction Place A to Z", value: "ConvictionPlace" },
		{ label: "Conviction Place Z to A", value: "!ConvictionPlace" },
		{ label: "Race A to Z", value: "Race" },
		{ label: "Race Z to A", value: "!Race" },
		{ label: "Sex A to Z", value: "Sex" },
		{ label: "Sex Z to A", value: "!Sex" },
		{ label: "Height High to Low", value: "!Height" },
		{ label: "Height Low to High", value: "Height" },
		{ label: "Weight High to Low", value: "!Weight" },
		{ label: "Weight Low to High", value: "Weight" },
		{ label: "Hair Color A to Z", value: "HairColor" },
		{ label: "Hair Color Z to A", value: "!HairColor" },
		{ label: "Eye Color A to Z", value: "EyeColor" },
		{ label: "Eye Color Z to A", value: "!EyeColor" },
		{ label: "Admin Name A to Z", value: "AdminName" },
		{ label: "Admin Name Z to A", value: "!AdminName" },
	];

	AnyNonVerified: boolean = false;

	errorMessage: string = "";

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////

	loadOffenders() {
		if (this.SelectedVisitor == undefined || this.SelectedVisitor.PersonID == undefined) {
			this.AnyNonVerified = true;
			this.lstNotVerified = [];
			this.lstVerified = [];
			return;
		}

		this.loading = true;

		var result = this.visitorService.VisitorOffenderLookupSummarySelect(this.SelectedVisitor.PersonID);
		result.subscribe(
			(response: any) => {
				this.lstNotVerified = response.lstNotVerified;
				this.lstVerified = response.lstVerified;

				this.AnyNonVerified = this.lstNotVerified.length > 0;

				// this.onSortChange(this.sortOptions[0]);

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////

	onRefresh() {
		this.loadOffenders();
	}

	onMatch(Offender) {
		this.errorMessage = "";

		var MSG = "";
		MSG += "You are about to confirm that the visitor: " + String(this.SelectedVisitor.FirstName + " " + this.SelectedVisitor.LastName).trim() + ", ";
		MSG += "MATCHES a SEX OFFENDER with the same name. Do you want to continue?";

		this.confirmationService.confirm({
			key: "offenderlookupconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: MSG,
			header: "Offender Match",
			icon: "fa",
			accept: () => {
				this.FinishUpdate(Offender.OffenderID, 1);
			},
		});
	}

	onNoMatch(Offender) {
		this.errorMessage = "";

		var MSG = "";
		MSG += "You are about to confirm that the visitor: " + String(this.SelectedVisitor.FirstName + " " + this.SelectedVisitor.LastName).trim() + ", ";
		MSG += "DOES NOT MATCH a SEX OFFENDER with the same name. Do you want to continue?";

		this.confirmationService.confirm({
			key: "offenderlookupconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: MSG,
			header: "Offender Match",
			icon: "fa",
			accept: () => {
				this.FinishUpdate(Offender.OffenderID, 0);
			},
		});
	}

	FinishUpdate(OffenderID, IsOffender) {
		this.Processing = true;

		var parms: VisitorOffenderUpdateRequest = {
			OffenderID: OffenderID,
			IsOffender: IsOffender,
			IsVerified: 1,
		};

		var result = this.visitorService.VisitorOffenderUpdateEntry(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.loadOffenders();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "offenderlookupfinish",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the offender entry: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onPrintPass() {
		this.errorMessage = "";

		this.Processing = true;

		var result = this.visitorService.PrintPass(this.SelectedVisitor.VisitorPassID);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					var ref = this.dialogService.open(MsPrintPassInstructionsComponent, {
						header: "Print Pass",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							PassImageB64: response.PassImageB64,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "offenderlookupfinish",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not print the pass: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////

	onSortChange(val) {
		let value = val.value;

		if (value.indexOf("!") === 0) {
			this.sortOrder = -1;
			this.sortField = value.substring(1, value.length);
		} else {
			this.sortOrder = 1;
			this.sortField = value;
		}
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	CanPrint() {
		return (
			this.AnyNonVerified == false &&
			this.SelectedVisitor != undefined &&
			this.SelectedVisitor.VisitorPassID != undefined &&
			this.SelectedVisitor.VisitorPassID > 0
		);
	}

	/////////////////////////////////////////////////////////////////
}
